import { defineComponent } from "@vue/runtime-core";
import { packed } from "magnetar-common";
import { Component, defineAsyncComponent, FunctionalComponent, ref } from "vue";
import { useTimeoutFn } from "@vueuse/core";
import { ComponentProps } from "vue-component-type-helpers";

export const ToastAdapterString = defineComponent(
    ({ value }: { value: string }) => {
        return () => <div class="mag-toast-string">{value}</div>;
    }
);

export const ToastAdapterNotification = defineComponent(
    ({ notification }: { notification: packed.PackNotification }) => {
        const MagNotification = defineAsyncComponent(
            () => import("@/components/MagNotification.vue")
        );

        return () => (
            <MagNotification
                notification={notification}
                class="mag-toast-notification"
            />
        );
    }
);

export type ToastOptions = { lifetime?: number };
export const toastDefaults = { lifetime: 7000 };

export type Toast = {
    key: string;
    component: FunctionalComponent<
        {},
        {
            close: () => void;
        }
    >;
    closing?: boolean;
};

const toasts = ref<Toast[]>([]);

export const useToasts = () => toasts;
let toastId = 0;

export function magToast<T extends Component>(
    message: ComponentProps<T & {}>,
    adapter: { new (...args: any[]): T } | (FunctionalComponent & T),
    toastOptions?: ToastOptions
) {
    const Component = adapter;
    const key = toastId.toString();
    toastId++;

    const options = { ...toastDefaults, ...toastOptions };

    const component = ({}, { emit }) => {
        useTimeoutFn(() => {
            emit("close");
        }, options.lifetime);

        return <Component {...message} />;
    };

    component.emits = {
        close: () => true,
    };

    toasts.value.push({
        key,
        component,
    });
}
